module.exports = __webpack_public_path__ + "media/couriers/ups_logo_new-ba412489.png";